module.exports = __webpack_public_path__ + "img/skills_cloud.137e4441.png";